import { CartUpdateEvent, CartErrorEvent } from '@theme/events';

const TOAST_DURATION = 5000;

function showToast(message, isError = true) {
  const existing = document.querySelector('[data-problemloeser-toast]');
  if (existing) existing.remove();
  const toast = document.createElement('div');
  toast.setAttribute('data-problemloeser-toast', '');
  toast.className = `problemloeser-toast problemloeser-toast--${isError ? 'error' : 'success'}`;
  toast.setAttribute('role', isError ? 'alert' : 'status');
  toast.textContent = message;
  document.body.appendChild(toast);
  setTimeout(() => toast.remove(), TOAST_DURATION);
}

function getCheckedLines(button) {
  const outcomeContainer = button.closest('[data-problemloeser-state]') || document;
  const checkedLines = outcomeContainer.querySelectorAll('li[data-available="true"]:has(input[data-problemloeser-line-toggle]:checked)');
  return Array.from(checkedLines).map((li) => ({
    id: parseInt(li.dataset.variantId, 10),
    quantity: parseInt(li.dataset.qty, 10),
  }));
}

function updateButtonLabel(button) {
  const items = getCheckedLines(button);
  const count = items.length;
  if (count === 0) {
    button.disabled = true;
    button.textContent = 'Keine Produkte ausgewählt';
  } else {
    button.disabled = false;
    button.textContent = `${count} Produkt${count === 1 ? '' : 'e'} in den Warenkorb`;
  }
}

async function handleAddAll(event) {
  event.preventDefault();
  const button = event.currentTarget;
  const items = getCheckedLines(button);

  if (items.length === 0) return;

  button.disabled = true;
  const originalLabel = button.textContent;
  button.textContent = 'Wird hinzugefügt …';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (response.ok) {
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = cartResponse.ok ? await cartResponse.json() : null;
      document.dispatchEvent(
        new CartUpdateEvent(cart, 'problemloeser', { source: 'problemloeser', itemCount: cart?.item_count })
      );
      button.textContent = '✓ Hinzugefügt';
    } else if (response.status === 422) {
      const data = await response.json().catch(() => ({}));
      showToast(data.description || data.message || 'Ein Produkt konnte nicht hinzugefügt werden.');
      document.dispatchEvent(new CartErrorEvent('problemloeser', data.message || '', data.description || '', data.errors || {}));
      button.disabled = false;
      button.textContent = originalLabel;
    } else {
      throw new Error(`HTTP ${response.status}`);
    }
  } catch (err) {
    showToast('Etwas ist schiefgelaufen. Bitte erneut versuchen.');
    button.disabled = false;
    button.textContent = originalLabel;
  }
}

document.addEventListener('click', (e) => {
  const button = e.target.closest('[data-problemloeser-add-all]');
  if (button && !button.disabled) {
    handleAddAll({ preventDefault: () => e.preventDefault(), currentTarget: button });
  }
});

document.addEventListener('change', (e) => {
  const toggle = e.target.closest('[data-problemloeser-line-toggle]');
  if (!toggle) return;
  const outcomeContainer = toggle.closest('[data-problemloeser-state]');
  if (!outcomeContainer) return;
  const button = outcomeContainer.querySelector('[data-problemloeser-add-all]');
  if (button) updateButtonLabel(button);
});

// Initial label sync on load (in case of pre-rendered checked state mismatch)
document.querySelectorAll('[data-problemloeser-add-all]').forEach(updateButtonLabel);
